module.exports = __webpack_public_path__ + "static/media/AutomationPlanner.faaba581.png";